function InspectorHomepage(){
    return <div>
        InspectorHomepage
    </div>;
}
export default InspectorHomepage;